import axios from '../helpers/api';

export const oauthService = {
    getClient,
    saveAuthorizedToken,
};

async function getClient(id, secret) {
    try {
        const res = await axios.get(`/api/oauth/client/${id}/${secret}`);
        return res.data;
    } catch (error) {
        return error;
    }
}

async function saveAuthorizedToken(data) {
    try {
        const res = await axios.post('/api/oauth/authorize', data);
        return res.data;
    } catch (error) {
        return error;
    }
}
